export const GET_USER_DATA = 'getUserData'
export const GET_USER_IMAGE_PUT_URL = 'getUserImagePutUrl'
export const UPDATE_USER = 'updateUser'
export const UPDATE_CURRENT_USER = 'updateCurrentUser'
export const CHANGE_USER_PASSWORD = 'changePassword'
export const REQUEST_RESET_PASSWORD = 'requestResetPassword'
export const SUBMIT_RESET_PASSWORD = 'submitResetPassword'
